import Guid from "common/values/guid/guid";

export default class AssistantCitation {
  private readonly _fileId: Guid;
  private readonly _fileName: string;
  private readonly _page?: number;
  private readonly _nodeId?: Guid;
  private readonly _score?: number;
  private readonly _semanticScore?: number;
  private readonly _combinedScore?: number;
  private readonly _matched?: boolean;
  private readonly _text?: string;

  constructor(
    fileId: Guid, 
    fileName: string,
    page?: number,
    nodeId?: Guid,
    score?: number,
    semanticScore?: number,
    combinedScore?: number,
    matched?: boolean,
    text?: string
  ) {
    this._fileId = fileId;
    this._fileName = fileName;
    this._page = page;
    this._nodeId = nodeId;
    this._score = score;
    this._semanticScore = semanticScore;
    this._combinedScore = combinedScore;
    this._matched = matched;
    this._text = text;
  }

  public get fileId(): Guid {
    return this._fileId;
  }

  public get fileName(): string {
    return this._fileName;
  }

  public get page(): number | undefined {
    return this._page;
  }

  public get nodeId(): Guid | undefined {
    return this._nodeId;
  }

  public get score(): number | undefined {
    return this._score;
  }

  public get semanticScore(): number | undefined {
    return this._semanticScore;
  }

  public get combinedScore(): number | undefined {
    return this._combinedScore;
  }

  public get matched(): boolean | undefined {
    return this._matched;
  }

  public get text(): string | undefined {
    return this._text;
  }

  toString(): string {
    return `
      File ID: ${this._fileId}, 
      File Name: ${this._fileName},
      Page: ${this._page},
      Node ID: ${this._nodeId},
      Score: ${this._score},
      Semantic Score: ${this._semanticScore},
      Combined Score: ${this._combinedScore},
      Matched: ${this._matched},
      Text: ${this._text}
    `;
  }
}
